import React from "react";
import { RCCGrid, RCCIcon, RCCProgress } from "react-common-components";
import Card from "src/components/Card";
import { DivWithWrap } from "src/components/OrgChart/components/ListCardOKR/styles";
import Photo from "src/components/Photo";
import { useTranslation } from "src/context/Translations/context";
import formatDate from "src/utils/formatDate";
import { ICardProject } from "./interface";
import HoursProjectsContainer from "../HoursProjects/container";

const CardProjects: React.FC<ICardProject> = ({
	project,
	colorSituation,
	options
}) => {
	const { REACT_APP_S3_ADDRESS, REACT_APP_S3_DIRECTORY } = process.env;
	const { translate, currentLanguage } = useTranslation();

	return (
		<>
			<Card
				color={colorSituation}
				options={options(project)}
				title={`${project.fullTitle}`}
				hidePercentage
				key={`${project.pra002Id}`}
			>
				<RCCGrid container item alignItems="center" >
					<DivWithWrap style={{marginRight: "0.5rem"}}>
						<Photo 
							name={project.pra002Efa005Nome}
							link={project.pra002Efa005Imagem && `${REACT_APP_S3_ADDRESS}/${REACT_APP_S3_DIRECTORY}/imagens_usuarios/${project.pra002Efa005Imagem}`}
							hover
						/>
						{project.pra002Efa005Nome}
					</DivWithWrap>
					<DivWithWrap style={project.pra002Dtiniest !== null ? { flexDirection: "column", alignItems: "baseline" } : {}}>
						<DivWithWrap>
							<div style={{marginRight: "10px"}}>
								{
									project.pra002ControlaHoras === "S" &&
									<HoursProjectsContainer projectId={project.pra002Id}/>
								}
							</div>
							<RCCIcon name="calendar" size={16} color="var(--default-color-font)" />
							 {formatDate(project.pra002Dtiniest, currentLanguage)} - {formatDate(project.pra002Dtfimest, currentLanguage)}			
						</DivWithWrap>
					</DivWithWrap>
					<RCCGrid 
						container 
						item 
						justifyContent="space-between"
					>
						<RCCGrid 
							container 
							item 
							xs={6}
							styleInline="padding: 10px"
						>
							<b>{`% ${translate("Conclusão")}: `}</b>
							<RCCProgress 
								color={`var(--${project.completionPercentageColor})`}
								layout="line"
								value={project.completionPercentage || 0}
							/>
						</RCCGrid>
						<RCCGrid 
							container 
							item 
							xs={6}
							styleInline="padding: 10px"
						>
							<b>{`% ${translate("Previsto")}: `}</b>
							<RCCProgress 
								layout="line"
								value={project.expectedPercentage || 0}
							/>
						</RCCGrid>
					</RCCGrid>				
				</RCCGrid>

				<p><b>{`${translate("Ações Concluídas")}: `}</b>{project.completed}/{project.count}</p>

			</Card>		
		</>
	);

};

export default CardProjects;
